export const InheritanceSettingsStorageKey = 'inheritance-settings';
